import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Table } from 'primeng/table';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { OrcamentoService } from 'src/app/admihair/service/orcamento.service';
import { Orcamento } from 'src/app/admihair/api/dto/orcamento';

@Component({
  selector: 'app-orcamentos-e-pacotes-listar',
  templateUrl: './orcamentos-e-pacotes-listar.component.html',
  styleUrls: ['./orcamentos-e-pacotes-listar.component.scss']
})
export class OrcamentosEPacotesListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  loading: boolean = true;
  listaOrcamentos: Orcamento[] = [];

  constructor(private orcamentoService: OrcamentoService,
    private confirmationService: ConfirmationService,
    erroService: ErroService, storageService: UtilStorageService,
    activatedRoute: ActivatedRoute,
    router: Router) {
    super(erroService, storageService,router, activatedRoute);
  }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.verificarPermissoes();
    if (this.permissaoListar) {
      this.listarOrcamentos();
    }
  }

  listarOrcamentos() {
    this.orcamentoService.listarPorEmpresa(this.getEmpresa().id).subscribe({
      next: (data: Orcamento[]) => {
        this.listaOrcamentos = data;
        this.setExibirSpinnerPrincipal(false);
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  excluir(id: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.orcamentoService.excluir(id).subscribe({
          next: () => {
            this.loading = true;
            this.listarOrcamentos();
            this.exibirMensagemSucesso();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        })
      }
    });
  }

  habilitarEditar(item: Orcamento): boolean {
    if(item.tipo === 'PACOTE' && item.status === 'PAGO') {
      return false;
    }
    return this.permissaoEditar;
  }

  habilitarExcluir(item: Orcamento): boolean {
    if(item.tipo === 'PACOTE' && item.status === 'PAGO') {
      return false;
    }
    return this.permissaoExcluir;
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_ORCAMENTOS_E_PACOTES');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_ORCAMENTOS_E_PACOTES');
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_ORCAMENTOS_E_PACOTES');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_ORCAMENTOS_E_PACOTES');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_ORCAMENTOS_E_PACOTES');
  }

}
